import { useOrganizationParentGetOrganizationSettings } from "@/orval/organization-parent";
import { useParentEnrollmentGetEnrollmentStudents } from "@/orval/parent-enrollment";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { SharedSchedule } from "@/components/schedule/shared-schedule";
import { Form } from "@/components/form/form";
import { OrganizationSemestersComboboxFormField } from "@/components/form/form-field/combobox/organization-semesters-combobox-form-field";
import { PortalPageHeader } from "@/components/portal-page-header";

export const Route = createFileRoute("/_app/organizations/$organizationId/parent/schedule")({
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationId } = Route.useParams();
  const [semesterId, setSemesterId] = useState<number | undefined>();
  const { data: parentOrganizationSettings, isLoading: isLoadingSettings } =
    useOrganizationParentGetOrganizationSettings(organizationId);

  const effectiveSemesterId =
    semesterId || parentOrganizationSettings?.nextSemesterId || parentOrganizationSettings?.activeSemesterId;

  const { data: enrollmentStudents, isLoading: isLoadingStudents } = useParentEnrollmentGetEnrollmentStudents(
    organizationId,
    effectiveSemesterId!,
    {
      query: {
        enabled: !!effectiveSemesterId,
      },
    },
  );

  return (
    <div className="flex flex-1 min-h-0 flex-col p-4 md:p-6">
      <PortalPageHeader
        className="mb-4 print:mb-2"
        title="Schedule"
        subtitle={<span className="print:text-black">View your family's class schedules</span>}
      />

      <div className="flex gap-2 mb-4 print:hidden">
        <Form<{ semesterId: number | undefined }>
          useFormProps={{
            defaultValues: {
              semesterId: effectiveSemesterId ?? undefined,
            },
          }}
          onChange={(data) => {
            setSemesterId(data.semesterId);
          }}
        >
          <OrganizationSemestersComboboxFormField name="semesterId" organizationId={organizationId} className="w-64" />
        </Form>
      </div>

      <SharedSchedule
        isLoading={isLoadingSettings || isLoadingStudents}
        semesterId={effectiveSemesterId}
        students={enrollmentStudents}
      />
    </div>
  );
}
